var customPopUp = {
    setSize: (size = 'lg') => {
        $('#customPopUp .modal-dialog').removeClass('modal-lg modal-sm modal-md').addClass('modal-' + size);
    },
    show(cb = () => {}) {
        $('#customPopUp').one('shown.bs.modal', cb).modal('show');
      },
    hide: function () {
        $('#customPopUp').modal('hide');
    },
    html: function (content) {
        $("#customPopUpBody").html(content || '');
    },
    footerHtml: function (content) {
        if (elId("customPopUpFooter")) {
            elId("customPopUpFooter").innerHTML = (content) ? content : '';
        } else {
            console.error('not found css path #customPopUpFooter');
        }
    }
};

function CognitoApi() {

    //////////////public methods
    this.login = function (username, password, callback) {
        var authenticationData = {
            Username: username,
            Password: password,
        };

        var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
        var cognitoUser = _getCognitoUser(username);

        const totpMfaSettings = {
            PreferredMfa: true,
            Enabled: true,
        };

        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
              cognitoUser.getUserData(async (err, data) => {
                if (err) {
                  alert(err.message || JSON.stringify(err));
                  return;
                }

                const { PreferredMfaSetting } = data;

                try {
                  if (PreferredMfaSetting !== "SOFTWARE_TOKEN_MFA" && isEnabledMFA(data)) {
                    await setupMFA();
                  }

                  fetch(process.env.BACKEND_API + '/occo-owner/user/my-info/retrieve', {
                    method: 'POST',
                    headers: { 'Authorization': result.idToken.jwtToken, "Content-Type": "application/json" },
                    body: JSON.stringify({}),
                  })
                    .then(response => response.json())
                    .then(function (response) {
                      callback.onSuccess(response.result);
                    }).catch(function (err) {
                    callback.onFailure(err);
                  });
                } catch (err) {
                  cognitoApi.signOut();
                  callback.onFailure(err);
                }
              });

            },

            totpRequired: function () {
                console.info("Need to set TOTP");
                modalWithInputCodeOTP(code => {
                    cognitoUser.sendMFACode(code, this, "SOFTWARE_TOKEN_MFA");
                });
            },

            newPasswordRequired: function (userAttributes, requiredAttributes) {
                callback.newPasswordRequired(username, cognitoUser.Session);
            },

            onFailure: function (err) {
                callback.onFailure(err);
            },

        });

        function getSub(userData) {
            return userData.UserAttributes.find(attr => attr.Name === 'sub').Value;
        }

        function isEnabledMFA(userData) {
            const user = process.env.TOTP_DISABLED_USERS.split(',').find(user => user === getSub(userData));
            return user === undefined;
        }

        async function setupMFA() {
            return new Promise((resolve, reject) => {
                cognitoUser.associateSoftwareToken({
                    associateSecretCode: function (secretCode) {
                        console.info("AssociateSecretCode");
                        console.info("Display QR Code");

                        const url = `otpauth://totp/${username}?secret=${secretCode}&issuer=${process.env.TOTP_ISSUER}`;
                        console.info("Your secret Code: " + secretCode);
                        modalWithQRCode(url, secretCode => {
                            cognitoUser.verifySoftwareToken(
                                secretCode,
                                "My TOTP device",
                                {
                                    onFailure: function (err) {
                                        console.error(err.message || JSON.stringify(err));
                                        reject(err);
                                    },
                                    onSuccess: function (result) {
                                        console.info(result);
                                        enableMFA().then(() => resolve());
                                    },
                                }
                            );
                        });
                    },
                    onFailure: function (err) {
                        console.error(err.message || JSON.stringify(err));
                    },
                });
            });
        }

        async function enableMFA() {
            return new Promise((resolve, reject) => {
                cognitoUser.setUserMfaPreference(
                    null,
                    totpMfaSettings,
                    function (err, result) {
                        if (err) {
                            console.error(err.message || JSON.stringify(err));
                            return reject(err);
                        }
                        console.log("call result " + result);
                        resolve(result);
                    }
                );
            });
        }
    };

    this.changeCogUserPassword = function (session, username, newPassword, callback) {
        var cognitoUser = _getCognitoUser(username);
        cognitoUser.Session = session;
        cognitoUser.completeNewPasswordChallenge(newPassword, [], {
            onSuccess: function (result) {
                callback(null, result);
            },
            onFailure: function (err) {
                callback(err, null);
            }
        });
    };

    this.forgotPassword = function (username, callback) {
        var cognitoUser = _getCognitoUser(username);
        cognitoUser.forgotPassword({
            onSuccess: function (result) {
                callback(null, result);
            },
            onFailure: function (err) {
                callback(err, null);
            },
        });
    };

    this.confirmPassword = function (username, verificationCode, newPassword, callback) {
        var cognitoUser = _getCognitoUser(username);
        cognitoUser.confirmPassword(verificationCode, newPassword, {
            onSuccess: function (result) {
                callback(null, result);
            },
            onFailure: function (err) {
                callback(err, null);
            }
        });
    };

    this.signOut = function () {
        var cognitoUser = _getCurrentUser();
        if (cognitoUser != null) {
            cognitoUser.signOut();
        }
    };

    this.getApiKey = function (callback) {
        var cognitoUser = _getCurrentUser();
        if (cognitoUser == null) {
            var err = {};
            err.type = "unauthorized_user";
            callback(err, null);
            return;
        }
        cognitoUser.getSession(function (err, session) {
            if (err || !session.isValid()) {
                var error = {};
                error.type = "unauthorized_user";
                if (err) {
                    error.innerError = err;
                }
                callback(error, null);
                return;

            }
            callback(null, session.getIdToken().getJwtToken());
        });

    };

    //////////////private methods
    function _getCurrentUser() {
        var userPool = _getUserPool();
        var cognitoUser = userPool.getCurrentUser();
        return cognitoUser;
    }

    function _getCognitoUser(username) {
        var userPool = _getUserPool();
        var userData = {
            Username: username,
            Pool: userPool
        };
        var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        return cognitoUser;
    }

    function _getUserPool() {
        var userPool = new AmazonCognitoIdentity.CognitoUserPool({
          UserPoolId: process.env.POOL_DATA_USER_ID,
          ClientId: process.env.POOL_DATA_CLIENT_ID
        });
        return userPool;
    }

    function modalWithQRCode(text, callback) {
        console.log('show modal with qr code');
        customPopUp.setSize('sm');
        customPopUp.html(`
            <div>
                <div id="qrCodeCont" style="text-align: center;margin: 15px 0 30px;"></div>
                <p style="margin-top: 10px;">Open Authenticator App then Scan this QR code and enter the code</p>
                <div class="input-group">
                   <input type="text" id="otp-code" class="form-control" autocomplete="off" placeholder="Code" />
                   <span class="input-group-btn">
                      <button class="btn btn-primary" type="button" id="submit-code">Submit</button>
                   </span>
                </div>
                <p style="margin: 10px 0 0;"><i class="fa fa-question-circle fa-lg"></i> <a href="" class="first-use-instructions">First use instructions</a></p>

                <div class="instruction" style="display: none;">
                   <h3 style="text-align: center;margin-top: 10px;">Instruction</h3>
                   
                   <p><b>1.</b> Go to App Store (if using iPhone) or Play Store (if using Android)</p>
                   <p><b>2.</b> Search for, and install the <code>Google Authenticator</code></p>
                   <p><b>3.</b> Open the Authenticator app</p>
                   <p><b>4.</b> Tap "Get Started". This takes you to the "Setup your first account" screen.</p>
                   <p><b>5.</b> Select a setup method named: "Scan a QR code"</p>
                   <p><b>6.</b> Scan the QR code you see on this page. A number will be displayed on your phone.</p>
                   <p style="margin-bottom: 0"><b>7.</b> Enter that number on this page</i></p>
                </div>
            </div>
        `);
        const $qrCodeCont = $("#qrCodeCont");
        $qrCodeCont.qrcode({
            text: text,
            size: 240,
            mode: 0,
            mSize: 0.045,
            mPosX: 0.5,
            mPosY: 0.5,
            fontcolor: '#000',
            fontname: 'Arial',
            ecLevel: 'H',
            render: 'image',
        });
        customPopUp.show();
        const handler = () => {
            const code = $("#otp-code").val();
            callback(code);
            customPopUp.hide();
        };
        $("#otp-code").on("keyup", (e) => {
            if (e.keyCode === 13) {
                handler();
            }
        });
        $("#submit-code").on("click", handler);

        $(".first-use-instructions").on("click", (e) => {
            e.preventDefault();
            $(".instruction").toggle();
        });
    }

    function modalWithInputCodeOTP(callback) {
        console.log('show modal with input code');
        customPopUp.setSize('sm');
        customPopUp.html(`
            <div>
               <p>Input code from Authenticator App</p>
               <div class="input-group">
                  <input type="text" id="otp-code" class="form-control" autocomplete="off" placeholder="Code" />
                  <span class="input-group-btn">
                    <button class="btn btn-primary" type="button" id="submit-code">Submit</button>
                  </span>
                </div>
            </div>
        `);
        customPopUp.show(() => {
            $('#otp-code').focus();
          });
        const handler = () => {
            const code = $("#otp-code").val();
            callback(code);
            customPopUp.hide();
        };
        $("#otp-code").on("keyup", (e) => {
            if (e.keyCode === 13) {
                handler();
            }
        });
        $("#submit-code").on("click", handler);
    }
}

var cognitoApi = new CognitoApi();
export default cognitoApi;